
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 8.667h1.333V7.333H2v1.334zm0 2.666h1.333V10H2v1.333zM2 6h1.333V4.667H2V6zm2.667 2.667H14V7.333H4.667v1.334zm0 2.666H14V10H4.667v1.333zm0-6.666V6H14V4.667H4.667zM2 8.667h1.333V7.333H2v1.334zm0 2.666h1.333V10H2v1.333zM2 6h1.333V4.667H2V6zm2.667 2.667H14V7.333H4.667v1.334zm0 2.666H14V10H4.667v1.333zm0-6.666V6H14V4.667H4.667z","fill":"currentColor"}})])
          )
        }
      }
    